"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusIndicator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var StatusIndicator = function (_a) {
    var enabled = _a.enabled;
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", sx: {
            justifyContent: 'center',
            alignItems: 'center',
        }, spacing: "0.8rem" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    width: '8px',
                    height: '8px',
                    borderRadius: '9999px',
                    backgroundColor: enabled ? 'success.main' : 'error.main',
                } }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "span", variant: "bodySmall", sx: {
                    color: 'primary.400',
                } }, { children: !enabled ? 'Inactive' : 'Active' }))] })));
};
exports.StatusIndicator = StatusIndicator;
